"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlyStringNumbers = exports.getPhoneType = exports.getCountry = exports.getNumber = exports.formatPhoneNumber = void 0;
const libphonenumber_js_1 = require("libphonenumber-js");
const types_1 = require("@smartsuite/types");
const phone_country_1 = require("./phone-country");
const formatPhoneNumber = (value, showPhoneType = false) => {
    const extension = value.phone_extension;
    const numberStr = (0, exports.getNumber)(value);
    const result = extension ? `${numberStr} x${extension}` : numberStr;
    if (showPhoneType && result) {
        return `${(0, exports.getPhoneType)(value)} : ${result}`;
    }
    return result;
};
exports.formatPhoneNumber = formatPhoneNumber;
const getNumber = (value, numberFormat = "INTERNATIONAL") => {
    var _a, _b;
    const phoneNumberString = (_a = value.phone_number) !== null && _a !== void 0 ? _a : "";
    const country = (_b = value.phone_country) !== null && _b !== void 0 ? _b : types_1.DEFAULT_COUNTRY;
    try {
        const phoneNumber = (0, libphonenumber_js_1.parsePhoneNumber)(phoneNumberString, country);
        if (!(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.isValid())) {
            return phoneNumberString;
        }
        return phoneNumber.format(numberFormat);
    }
    catch (e) {
        return phoneNumberString;
    }
};
exports.getNumber = getNumber;
const getCountry = (value) => {
    if (value.phone_country) {
        return value.phone_country;
    }
    return (0, phone_country_1.formatPhoneCountry)(value);
};
exports.getCountry = getCountry;
const getPhoneType = (value) => {
    var _a;
    return types_1.phoneTypeTitles[(_a = value.phone_type) !== null && _a !== void 0 ? _a : types_1.PhoneTypes.mobile];
};
exports.getPhoneType = getPhoneType;
const onlyStringNumbers = (str) => {
    return str.replace(/\D/g, "");
};
exports.onlyStringNumbers = onlyStringNumbers;
